import {computed, ComputedRef} from "vue"
import store from "@/vue/planning/store/store"
import screenType from "@/vue/planning/computed/screenType"
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"
import availableNonTransportPackageCodes from "@/vue/planning/computed/availableNonTransportPackageCodes"

const packagesToDisplay: ComputedRef<Array<any>> = computed(() => {
    if (screenType.value === "mobile") return store.getters.availablePackCodes;
    if (store.getters.transport) return availableTransportPackCodes.value;
    if(store.state.season == 'E') {
        store.state.packCode = "HS"
        const filteredPackagesForSummer= []
        // @ts-ignore: pack.codePackage should always be an obj
        const filteredPackageHS = availableNonTransportPackageCodes.value.find(pack => pack.codePackage ==  "HS");
        // @ts-ignore: pack.codePackage should always be an obj
        const filteredPackagePMA = availableNonTransportPackageCodes.value.find(pack => pack.codePackage ==  "PMA");
        filteredPackagePMA ? filteredPackagesForSummer.push(filteredPackageHS, filteredPackagePMA) : filteredPackagesForSummer.push(filteredPackageHS)
        return filteredPackagesForSummer
    } else {
        return availableNonTransportPackageCodes.value;
    }
})

export default packagesToDisplay